import { render, staticRenderFns } from "./DropdownNotification.vue?vue&type=template&id=219e1529&scoped=true"
import script from "./DropdownNotification.vue?vue&type=script&lang=js"
export * from "./DropdownNotification.vue?vue&type=script&lang=js"
import style0 from "./styles/dropdown-notification.scss?vue&type=style&index=0&id=219e1529&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219e1529",
  null
  
)

export default component.exports